module.exports = __webpack_public_path__ + "img/hero-nava.2aa86851.png";